import React, {useEffect, useMemo, useState} from 'react'
import styles from './UIGameHelpChatLogsButton.module.scss'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils.ts'
import {LobbyImage} from '@colonist/types'
import clsx from 'clsx'
import {useGameStore} from '../../../store/GameStoreContext.ts'
import type {UIGameFeedsPortraitVisibility} from '../../UIGameFeeds/UIGameFeedsPortrait.tsx'

interface ButtonProps {
    image: LobbyImage.Chat | LobbyImage.Log
    isSelected: boolean
    isBubbleVisible: boolean
    onClick: () => void
}

export const Button = ({
    image,
    isSelected,
    isBubbleVisible,
    onClick,
}: ButtonProps) => (
    <div onClick={onClick}className={clsx(styles.buttonContainer, {
        [styles.selected]: isSelected,
        [styles.bubble]: isBubbleVisible,
    })}>
        <div className={styles.icon}>
            <img src={getLobbyImagePath(image)} />
        </div>
    </div>
)

interface UIGameHelpOpenChatLogsButtonProps {
    feedsPortraitVisibility: UIGameFeedsPortraitVisibility
    setFeedsPortraitVisibility: (visibility: UIGameFeedsPortraitVisibility) => void
}

export const UIGameHelpOpenChatLogsButton = ({
    feedsPortraitVisibility,
    setFeedsPortraitVisibility,
}: UIGameHelpOpenChatLogsButtonProps) => {
    const gameChatState = useGameStore((state) => state.gameState.gameChatState)
    const [numberOfReadMessages, setNumberOfReadMessages] = useState(0)
    const numberOfMessages = useMemo(() => Object.keys(gameChatState).length, [gameChatState])
    const isChatBubbleVisible = numberOfMessages > numberOfReadMessages

    const isOpenSettings = useGameStore((state) => state.gameUserSettings.isOpenSettings)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)

    useEffect(() => {
        if(isOpenSettings === true || isPaused === true) {
            setFeedsPortraitVisibility('none')
        }
    }, [isOpenSettings, isPaused])

    useEffect(() => {
        if(feedsPortraitVisibility === 'chat') {
            setNumberOfReadMessages(numberOfMessages)
        }
    }, [numberOfMessages, feedsPortraitVisibility])

    const handleChatClick = () => {
        setFeedsPortraitVisibility(feedsPortraitVisibility === 'chat' ? 'none' : 'chat')
        setNumberOfReadMessages(numberOfMessages)
    }

    const handleLogClick = () => {
        setFeedsPortraitVisibility(feedsPortraitVisibility === 'log' ? 'none' : 'log')
    }

    return (
        <div className={styles.container}>
            <Button
                image={LobbyImage.Log}
                isSelected={feedsPortraitVisibility === 'log'}
                isBubbleVisible={false}
                onClick={handleLogClick} />
            <Button
                image={LobbyImage.Chat}
                isSelected={feedsPortraitVisibility === 'chat'}
                isBubbleVisible={isChatBubbleVisible}
                onClick={handleChatClick} />
        </div>
    )
}
